import React from "react";
import HTML_Logo from "../../assets/logos/html5_logo.png";
import CSS_Logo from "../../assets/logos/css3_logo.png";
import JS_Logo from "../../assets/logos/JS_logo.png";
import React_Logo from "../../assets/logos/react_logo.png";
import Express_Logo from "../../assets/logos/express_logo.png";
import Knex_Logo from "../../assets/logos/knex_logo.png";
import Node_Logo from "../../assets/logos/node_logo.png";
import PostgreSQL_Logo from "../../assets/logos/postgreSQL_logo.png";
import Cypress_Logo from "../../assets/logos/cypress_logo.png";

function DevelopmentInfo() {
  return (
    <div id="development-header-info-container">
      <div id="development-header-info" className="fade-in three">
        <h2>SKILLS</h2>
        <p>I am Frontend Engineer skilled in the following technologies:</p>
        <div id="development-header-skills">
          <div className="dev-skill">
            <img src={HTML_Logo} alt="html5 logo" />
            <h4>HTML5</h4>
          </div>
          <div className="dev-skill">
            <img src={CSS_Logo} alt="css3 logo" />
            <h4>CSS3</h4>
          </div>
          <div className="dev-skill">
            <img src={JS_Logo} alt="javascript logo" />
            <h4>JavaScript</h4>
          </div>
          <div className="dev-skill">
            <img src={React_Logo} alt="react logo" />
            <h4>React.js</h4>
          </div>
          <div className="dev-skill">
            <img src={React_Logo} alt="react native logo" />
            <h4>React Native</h4>
          </div>
        </div>
        <p>I have also worked with the following backend technologies:</p>
        <div id="development-header-skills">
          <div className="dev-skill">
            <img src={Node_Logo} alt="node logo" />
            <h4>Node</h4>
          </div>
          <div className="dev-skill">
            <img src={PostgreSQL_Logo} alt="postgresql logo" />
            <h4>PostgreSQL</h4>
          </div>
          <div className="dev-skill">
            <img src={Express_Logo} alt="express logo" />
            <h4>Express</h4>
          </div>
          <div className="dev-skill">
            <img src={Knex_Logo} alt="knex logo" />
            <h4>Knex</h4>
          </div>
          <div className="dev-skill">
            <img src={Cypress_Logo} alt="cypress logo" />
            <h4>Cypress</h4>
          </div>
        </div>
        <p>I am currently learning new Skills:</p>
        <div id="development-header-more-skills">
          <ul>
            <li>Vibe Coding</li>
            <li>Claude</li>
            <li>Copilot</li>
          </ul>
        </div>
        <p>Check out some of my work below.</p>
      </div>
    </div>
  );
}

export default DevelopmentInfo;
